// -----------------------------------------------------------------------------
// This file was copied from packages/shared/bop-view-definitions/src by scripts/sync-bop-view-definitions.sh.
// Do not edit this copied version directly.
// It is generated by the sync script and will be overwritten.
// -----------------------------------------------------------------------------

import {
    DEFAULT_CUSTOMER_INVOICE_COLUMNS,
    DEFAULT_INVOICE_COLUMNS,
    InvoiceColumns,
    MANDATORY_CUSTOMER_INVOICE_COLUMNS,
    MANDATORY_INVOICE_COLUMNS,
} from './columns';

export enum SUPPORTED_TABLES_ENUM {
    INVOICES = 'invoices',
    /** The invoice list on the customer profile page. Configured separately from INVOICES. */
    CUSTOMER_INVOICES = 'customer_invoices',
}

export const SUPPORTED_TABLES = Object.values(SUPPORTED_TABLES_ENUM) as readonly SUPPORTED_TABLES_ENUM[];

export type SupportedBopTable = (typeof SUPPORTED_TABLES)[number];
export type BopColumn = `${InvoiceColumns}`;

export const VIEW_DEFINITIONS: Record<SupportedBopTable, typeof InvoiceColumns> = {
    [SUPPORTED_TABLES_ENUM.INVOICES]: InvoiceColumns,
    [SUPPORTED_TABLES_ENUM.CUSTOMER_INVOICES]: InvoiceColumns,
};

export const DEFAULT_VIEW_DEFINITIONS: Record<SupportedBopTable, readonly BopColumn[]> = {
    [SUPPORTED_TABLES_ENUM.INVOICES]: DEFAULT_INVOICE_COLUMNS,
    [SUPPORTED_TABLES_ENUM.CUSTOMER_INVOICES]: DEFAULT_CUSTOMER_INVOICE_COLUMNS,
};

export const MANDATORY_VIEW_DEFINITIONS: Record<SupportedBopTable, readonly BopColumn[]> = {
    [SUPPORTED_TABLES_ENUM.INVOICES]: MANDATORY_INVOICE_COLUMNS,
    [SUPPORTED_TABLES_ENUM.CUSTOMER_INVOICES]: MANDATORY_CUSTOMER_INVOICE_COLUMNS,
};

export const ALL_BOP_COLUMNS = [
    // Tables can share a column enum, so de-duplicate across the definitions.
    ...new Set(Object.values(VIEW_DEFINITIONS).flatMap((definition) => Object.values(definition))),
];

export const isSupportedBopTable = (tableName: string): tableName is SupportedBopTable =>
    (SUPPORTED_TABLES as readonly string[]).includes(tableName);

export const getAllowedColumnsForTable = (tableName: string): string[] => {
    if (!isSupportedBopTable(tableName)) {
        return [];
    }

    return Object.values(VIEW_DEFINITIONS[tableName]);
};

export const isValidColumnForTable = (tableName: string, column: string): column is BopColumn =>
    getAllowedColumnsForTable(tableName).includes(column);

export const areValidColumnsForTable = (tableName: string, columns: readonly string[]): boolean =>
    columns.length > 0 && columns.every((column) => isValidColumnForTable(tableName, column));

export const getMandatoryColumnsForTable = (tableName: string): readonly BopColumn[] => {
    if (!isSupportedBopTable(tableName)) {
        return [];
    }

    return MANDATORY_VIEW_DEFINITIONS[tableName];
};

export const ensureMandatoryColumnsForTable = (tableName: string, columns: readonly string[]): string[] => {
    const missingMandatoryColumns = getMandatoryColumnsForTable(tableName).filter((column) => !columns.includes(column));

    return [...columns, ...missingMandatoryColumns];
};
